/**
 * router name 为大驼峰
 */

// import oldEditor from '../views/editorResume/cvsEditor/index'
// import Editor from '../views/editorResume/editorCv/index'

const cvRouter = [
	{
		path: '/',
		name: 'Home',
		component: () => import(/* webpackChunkName: "account" */ '@/views/Home'),
		// redirect:"/identity"
	},
	{
		path: '/cvs/:token/editor',
		name: 'CvEditor',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/editorResume/index')
		// component: () => import(/* webpackChunkName: "cvs" */ '@/views/editor2025/index')
	},
	{
		path: '/cvs/:token/share',
		name: 'CvShare',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cvsShare/index')
	},
	{
		path: '/mentor/cvs/:token/editor',
		name: 'MentorCvEditor',
		component: () => import(/* webpackChunkName: "mentor" */ '@/views/editorResume/index')
	},
	{
		path: '/cvs/resume-pdf',
		name: 'ResumePdf',
		component: () => import(/* webpackChunkName: "mentor" */ '@/views/resumePdf/index')
	},
	{
		path: '/cvs-old',
		name: 'Cvs',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cvs-old/index')
	},
	{
		path: '/cvs',
		name: 'Cvs',
		component: () => import(/* webpackChunkName: "cvsNew" */ '@/views/cvs/index')
	},
	{
		path: '/cvs/trash',
		name: 'CvsTrash',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cvs/trash')
	},
	{
		path: '/cvs/favorite',
		name: 'CvFavorite',
		component: () => import(/* webpackChunkName: "cvs" */ '@/views/cvs/favorite')
	},
	{
		path: '/inbox',
		name: 'Inbox',
		component: () => import(/* webpackChunkName: "account" */ '@/views/inbox/index')
	},
	{
		path: '/service/orders',
		name: 'ServiceOrders',
		component: () => import(/* webpackChunkName: "service" */ '@/views/service/orders/index')
	},
	{
		path: '/service/pay_success/:token',
		name: 'ServicePaySuccess',
		component: () => import(/* webpackChunkName: "service" */ '@/views/service/pay_success/index')
	},
	{
		path: '/service/task/:token',
		name: 'ServiceTask',
		component: () => import(/* webpackChunkName: "service" */ '@/views/service/task/index')
	},
	//校招详情
	{
		path: '/comp_recruit_infos/:id',
		name: 'Detail',
		component: () => import(/* webpackChunkName: "jobDetail" */ '@/views/jobs/jobDetail')
	},
	// 导师后台
	{
		path: '/mentor/tasks',
		name: 'MentorTasks',
		component: () => import(/* webpackChunkName: "mentor" */ '@/views/mentor/tasks/index')
	},
	//支付成功
	{
		path: '/pay/success',
		name: 'PaySuccess',
		component: () => import(/* webpackChunkName: "account" */ '@/views/account/user/pay-success')
	},
	// 导师账单
	{
		path: '/mentor/tasks/month_statement',
		name: 'MentorMonthStatement',
		component: () => import(/* webpackChunkName: "mentor" */ '@/views/mentor/tasks/month_statement')
	},
	{
		path: '/mentor/tasks/statement',
		name: 'MentorMonthStatement',
		component: () => import(/* webpackChunkName: "mentor" */ '@/views/mentor/tasks/statement')
	},
	// 身份选择
	{
		path: '/template_matches/new',
		name: 'TemplateMatchesNew',
		component: () => import(/* webpackChunkName: "account" */ '@/views/identity/index')
	},
  // 毕业时间、毕业学校
  {
    path: '/jobs/graduation',
    name: 'Graduation',
		component: () => import(/* webpackChunkName: "account" */ '@/views/identity/graduation')
  },
  // 求职状态
  {
    path: '/jobs/state',
    name: 'State',
    component: () => import(/* webpackChunkName: "account" */ '@/views/identity/state')
  },
	// 意向城市、意向职业选择
	{
		path: '/jobs/intention',
		name: 'JobsIntention',
		component: () => import(/* webpackChunkName: "account" */ '@/views/identity/jobs_intention')
	},
	{
		path: '/cvs/privacy-clause',
		name: 'PrivacyClause',
		component: () => import(/* webpackChunkName: "account" */ '@/views/staticText/privacy')
	},
	{
		path: '/cvs/pay/privacy-clause',
		name: 'PrivacyClause',
		component: () => import(/* webpackChunkName: "account" */ '@/views/staticText/payPrivacy')
	},
  // 关注公司选择
	{
		path: '/onboading/select-company',
		name: 'SelectCompany',
		component: () => import(/* webpackChunkName: "account" */ '@/views/identity/jobs_company')
	}
]
export default cvRouter
